import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {useSimpleQuery} from '@frnt/base/hooks'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'

const DashboardSummariesServiceContext = createContext(undefined)

const DashboardSummariesServiceProvider = ({
  children,
  baseApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={DashboardSummariesServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={baseApiHost}
      valueCallback={(axios) => ({
        getMe: async () => {
          const {data} = await axios.get(`/api/v1/reporting/dashboard_summaries/me`)
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

DashboardSummariesServiceProvider.propTypes = {
  children: PropTypes.any,
  baseApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useDashboardSummariesService = () => {
  const context = useContext(DashboardSummariesServiceContext)
  if (context === undefined) {
    throw new Error('DashboardSummariesServiceContext was not provided. Make sure your component is a child of the DashboardSummariesServiceProvider.')
  }
  return context
}

const useCurrentDashboardSummaryQuery = ({accessToken, enabled, ...otherProps}) => {
  const dashboardSummariesService = useDashboardSummariesService()
  return useSimpleQuery({
    queryKey: `dashboard_summaries-get-${accessToken}`,
    queryFn: async () => dashboardSummariesService.getMe(),
    enabled: enabled !== undefined ? enabled : !!accessToken,
    ...otherProps
  })
}

export {DashboardSummariesServiceProvider, useDashboardSummariesService, useCurrentDashboardSummaryQuery}
